// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkOrder_wrapper__6gJ1v","col":"WorkOrder_col__pkZDx"};